import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { Reveal } from "../components/Reveal";
import { Marquee } from "../components/Marquee";

export default function Shop() {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pt-28">
      <section className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16" data-testid="shop-page">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.24em] text-gold mb-4">The Shop</p>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-moss leading-[0.95] max-w-3xl">
            Every jar, <span className="italic text-gold">nothing hidden.</span>
          </h1>
          <p className="mt-6 max-w-xl text-muted leading-relaxed">
            Two ingredient-first body butters made with rare natural butters sourced from Africa. Choose your size — and for
            Rich & Radiant, choose your shea.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-10 sm:grid-cols-2 lg:gap-16">
          {products.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      </section>
      <Marquee />
    </div>
  );
}
